module.exports = __webpack_public_path__ + "static/img/gifWallet.5864b6f9.png";